module.exports = __webpack_public_path__ + "img/icwithdraw.03141917.png";